import { useState } from "react";

const G = "#b8960c";

function SectionHeader({ label, title }) {
  return (
    <div className="mb-4">
      <p className="text-xs tracking-[0.25em] uppercase mb-1 font-semibold" style={{ color: G }}>{label}</p>
      <h2 style={{ fontFamily: 'Playfair Display, serif' }} className="text-3xl sm:text-4xl font-black text-white">{title}</h2>
      <div className="w-10 h-0.5 mt-2" style={{ background: G }} />
    </div>
  );
}

export default function Contact({ refs }) {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    const formData = new FormData(e.target);

    try {
      const res = await fetch("https://formspree.io/f/xjgzqbbb", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });

      if (res.ok) {
        setStatus("success");
        e.target.reset();
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }

    setLoading(false);
  };

  return (
    <section id="Contact" ref={el => (refs.current["Contact"] = el)} className="py-8">
      <SectionHeader label="Get in Touch" title="Contact" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
        <div>
          <p className="text-sm text-gray-400 leading-loose mb-6">Open to new opportunities in IT administration, support, or software engineering. Reach out and I will get back to you promptly.</p>
          <div className="space-y-3">
            {[["📧", "omonzi007@gmail.com", "mailto:omonzi007@gmail.com"], ["📞", "017616040167", "tel:017616040167"], ["📍", "Berlin, Germany", null]].map(([icon, text, href]) => (
              <div key={text} className="flex items-center gap-3 pb-3 border-b border-white/6">
                <span>{icon}</span>
                {href
                  ? <a href={href} className="text-xs text-gray-400 hover:text-yellow-500 transition-colors break-all">{text}</a>
                  : <span className="text-xs text-gray-400">{text}</span>
                }
              </div>
            ))}
          </div>
        </div>
        <div>
          <form onSubmit={handleSubmit} className="space-y-3">
            <input
              name="name"
              required
              className="w-full border border-white/10 px-4 py-3 text-xs text-gray-200 outline-none transition-all placeholder-gray-600 rounded-sm"
              style={{ background: "#1a1a1a" }}
              placeholder="Your name"
              type="text"
            />
            <input
              name="email"
              required
              className="w-full border border-white/10 px-4 py-3 text-xs text-gray-200 outline-none transition-all placeholder-gray-600 rounded-sm"
              style={{ background: "#1a1a1a" }}
              placeholder="Your email"
              type="email"
            />
            <textarea
              name="message"
              required
              className="w-full border border-white/10 px-4 py-3 text-xs text-gray-200 outline-none transition-all placeholder-gray-600 rounded-sm resize-y"
              style={{ background: "#1a1a1a" }}
              rows={5}
              placeholder="Your message"
            />
            {status === "success" && (
              <p className="text-xs text-green-400 font-medium">✅ Message sent! I will get back to you soon.</p>
            )}
            {status === "error" && (
              <p className="text-xs text-red-400 font-medium">❌ Something went wrong. Please try again.</p>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 text-xs font-bold tracking-widest uppercase rounded-sm transition-all duration-300"
              style={{ background: loading ? "#555" : G, color: "#0f0f0f", cursor: loading ? "not-allowed" : "pointer" }}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
